import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, DBCheckBoxObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationPostureSpine extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Posture - Spine' />
                    <label className={styles.label}>Spine</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSPINELORDOSIS'
                        className={styles.checkbox}
                        label='Normal'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSPINEKYPHOSIS'
                        className={styles.checkbox}
                        label='Forward'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSPINESCOLIOSIS'
                        className={styles.checkbox}
                        label='Lateral Flexion'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel}>Comments:</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSPINETXT'
                        className={styles.textarea}
                    />
                </div>
            </div >
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSPINELORDOSIS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSPINEKYPHOSIS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSPINESCOLIOSIS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSPINETXT
            ? true : false
    };
}

const connectedObservationPostureSpine = connect(mapStateToProps)(ObservationPostureSpine);
export { connectedObservationPostureSpine as ObservationPostureSpine };


